import React, { useState, useRef, useEffect } from 'react';
import { IoCloudUpload } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import '../../components/DashboardSeller/UploadPO.css';
import { getAuthToken } from "../../utils/auth";
import { createPurchaseInvoice } from '../../API/Api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const UploadPO = ({ isOpen, onClose, order, quotationId, onUploadSuccess }) => {
	const [files, setFiles] = useState([]);
	const fileInputRef = useRef();
	const [token, setToken] = useState(null);

	useEffect(() => {
		setToken(getAuthToken());
	}, []);

	if (!isOpen) return null;

	const handleFileChange = (e) => {
		const selectedFiles = Array.from(e.target.files);
		setFiles(prev => [...prev, ...selectedFiles]);
	};

	const handleFileRemove = (index) => {
		const updatedFiles = files.filter((_, i) => i !== index);
		setFiles(updatedFiles);
	};

	const handleSubmit = async () => {
		if (!files.length) {
			alert("Please select at least one file to upload.");
			return;
		}

		try {
			for (let file of files) {
				const formData = new FormData();
				formData.append('quotation_id', quotationId);
				formData.append('file', file);

				const response = await createPurchaseInvoice(formData);

				console.log('Upload successful:', response);
			}

			toast.success("Files uploaded successfully.");
			onUploadSuccess?.();
			onClose();
			setFiles([]);

		} catch (error) {
			console.error("Upload failed:", error);
			toast.error("Failed to upload file.");
		}
	};

	return (
		<div className="uploadpo-overlay">
			<ToastContainer position="top-right" autoClose={3000} />

			<div className="uploadpo-modal">
				<button className="uploadpo-close" onClick={onClose}>✖</button>

				<div className="uploadpo-container">
					<h3 className="uploadpo-label">Proforma Invoice</h3>

					<div className="payment-image-section">
						<div className="payment-upload-box" onClick={() => fileInputRef.current.click()}>
							<IoCloudUpload size={50} className="upload-icon" />
							<p className="upload-text">Browse Files to Upload</p>
							<p className="upload-format">(Format: JPG, PNG & PDF)</p>
							<input
								type="file"
								ref={fileInputRef}
								className="payment-file-input"
								accept=".jpg,.png,.pdf"
								multiple
								onChange={handleFileChange}
								style={{ display: 'none' }}
							/>
						</div>
					</div>

					{files.map((file, index) => (
						<div className="uploadpo-file-row" key={index}>
							<span className="uploadpo-filename">{file.name}</span>
							<RiDeleteBin5Line
								className="uploadpo-delete"
								size={18}
								onClick={() => handleFileRemove(index)}
							/>
						</div>
					))}
					<div className='main-button-po'>
						<button className="payment-modal-confirm-po font-poppins" onClick={handleSubmit}>Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UploadPO;

// import React, { useState, useRef, useEffect } from 'react';
// import { IoCloudUpload } from "react-icons/io5";
// import { RiDeleteBin5Line } from "react-icons/ri";
// import '../../components/DashboardSeller/UploadPO.css';
// import { getAuthToken } from "../../utils/auth";
// import { createPurchaseInvoice } from '../../API/Api';

// const UploadPO = ({ isOpen, onClose, order, quotationId, onUploadSuccess }) => {
// 	const [files, setFiles] = useState([]);
// 	const [isUploading, setIsUploading] = useState(false);
// 	const [error, setError] = useState(null);
// 	const fileInputRef = useRef();
// 	const [token, setToken] = useState(null);

// 	useEffect(() => {
// 		setToken(getAuthToken());
// 	}, []);

// 	if (!isOpen) return null;

// 	const handleFileChange = (e) => {
// 		const selectedFiles = Array.from(e.target.files);
// 		setFiles(prev => [...prev, ...selectedFiles]);
// 		setError(null); // Clear any previous errors when new files are selected
// 	};

// 	const handleFileRemove = (index) => {
// 		const updatedFiles = files.filter((_, i) => i !== index);
// 		setFiles(updatedFiles);
// 	};

// 	const handleSubmit = async () => {
// 		if (files.length === 0) {
// 			setError("Please select at least one file to upload");
// 			return;
// 		}

// 		setIsUploading(true);
// 		setError(null);

// 		try {
// 			const formData = new FormData();

// 			// Append files
// 			files.forEach((file) => {
// 				formData.append("files", file);  // For multiple files
// 			});

// 			if (quotationId) {
// 				formData.append("quotation_id", quotationId);  // Match backend expectation
// 			}

// 			// Call API
// 			const response = await createPurchaseInvoice(formData);

// 			console.log("Upload successful:", response);
// 			setFiles([]);
// 			onUploadSuccess?.();
// 			onClose();
// 		} catch (error) {
// 			console.error("Upload error:", error);
// 			setError(error.message || "Failed to upload files");
// 		} finally {
// 			setIsUploading(false);
// 		}
// 	};
// 	return (
// 		<div className="uploadpo-overlay">
// 			<div className="uploadpo-modal">
// 				<button className="uploadpo-close" onClick={onClose}>✖</button>

// 				<div className="uploadpo-container">
// 					<h3 className="uploadpo-label">Proforma Invoice</h3>

// 					<div className="payment-image-section">
// 						<div className="payment-upload-box" onClick={() => fileInputRef.current.click()}>
// 							<IoCloudUpload size={50} className="upload-icon" />
// 							<p className="upload-text">Browse Files to Upload</p>
// 							<p className="upload-format">(Format: JPG, PNG & PDF)</p>
// 							<input
// 								type="file"
// 								ref={fileInputRef}
// 								className="payment-file-input"
// 								accept=".jpg,.png,.pdf"
// 								multiple
// 								onChange={handleFileChange}
// 								style={{ display: 'none' }}
// 							/>
// 						</div>
// 					</div>

// 					{files.map((file, index) => (
// 						<div className="uploadpo-file-row" key={index}>
// 							<span className="uploadpo-filename">{file.name}</span>
// 							<RiDeleteBin5Line
// 								className="uploadpo-delete"
// 								size={18}
// 								onClick={() => handleFileRemove(index)}
// 							/>
// 						</div>
// 					))}

// 					{/* Display error message if any */}
// 					{error && <p className="upload-error">{error}</p>}

// 					<div className='main-button-po'>
// 						<button
// 							className="payment-modal-confirm-po font-poppins"
// 							onClick={handleSubmit}
// 							disabled={isUploading || files.length === 0}
// 						>
// 							{isUploading ? 'Uploading...' : 'Submit'}
// 						</button>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// };

// export default UploadPO;